export var getFilters = function (appliedFilters) {
    return Object.keys(appliedFilters).filter(function (filterKey) { return appliedFilters[filterKey] === true; });
};
